// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-dashboard-wrapper {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 10px;
    color: var(--psblue);
}
.my-dashboard {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: white;
    box-shadow: 0 0 10px darkgray;
    padding: 20px;
}
.user-section {
    display: flex;
    width: 100%;
    justify-content: center;
}
.user-data {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.change-password-form {
    width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px;
}
.change-password-form>* {
    margin-bottom: 10px;
}
.change-password-form input {
    cursor: text;
    width: 250px;
    height: 40px;
    padding: 0 10px;
    border: 1px solid var(--psblue);
}
.change-password-form input:focus {
    outline: none;
    outline: 1px solid var(--psblue)
}
.change-password-form button {
    width: 200px;
    height: 40px;
    cursor: pointer;
    background: var(--psblue);
    color: white;
    border: none;
    margin: 0 0 10px 0;
    width: 250px;
}
.change-password-form button:hover {
    background: var(--psblue-accent)
}

.change-password-form button:active {
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}
input:disabled {
    cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/myDashboard/myDashboard.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,6BAA6B;IAC7B,aAAa;AACjB;AACA;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,+BAA+B;AACnC;AACA;IACI,aAAa;IACb;AACJ;AACA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI;AACJ;;AAEA;IACI,sCAAsC;AAC1C;AACA;IACI,mBAAmB;AACvB","sourcesContent":[".my-dashboard-wrapper {\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-bottom: 10px;\n    color: var(--psblue);\n}\n.my-dashboard {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background: white;\n    box-shadow: 0 0 10px darkgray;\n    padding: 20px;\n}\n.user-section {\n    display: flex;\n    width: 100%;\n    justify-content: center;\n}\n.user-data {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n.change-password-form {\n    width: 400px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 30px;\n}\n.change-password-form>* {\n    margin-bottom: 10px;\n}\n.change-password-form input {\n    cursor: text;\n    width: 250px;\n    height: 40px;\n    padding: 0 10px;\n    border: 1px solid var(--psblue);\n}\n.change-password-form input:focus {\n    outline: none;\n    outline: 1px solid var(--psblue)\n}\n.change-password-form button {\n    width: 200px;\n    height: 40px;\n    cursor: pointer;\n    background: var(--psblue);\n    color: white;\n    border: none;\n    margin: 0 0 10px 0;\n    width: 250px;\n}\n.change-password-form button:hover {\n    background: var(--psblue-accent)\n}\n\n.change-password-form button:active {\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n}\ninput:disabled {\n    cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
